import { Component, ComponentChild, h } from 'preact'
import Panel from '../panel'
import InputGroup from '../ui-components/InputGroup'
import FeaturedTopicsManager from '../featured-topics/FeaturedTopicsManager'
import axios, { AxiosResponse } from 'axios'
import FeaturedTopic from './FeaturedTopic'
import { isInputEl } from '../../libs/typeGuards'

export interface FeaturedTopic {
  id: number
  title: string
  url: string
  contentType: string
  type?: string
}

interface Content {
  topics: (number|TopicData)[]
  firstTopicsNumber?: number
  buttonLabel?: string
  buttonURL?: string
}

interface TopicData {
  id: number
  type: string
}

interface NewData {
  topics: TopicData[]
  firstTopicsNumber: number
  title: string
  buttonLabel: string
  buttonURL: string
}

interface Props {
  title: string
  onChange: (state: {title: string, topics: TopicData[], firstTopicsNumber: number, buttonLabel: string, buttonURL: string}) => void
  switcher?: ComponentChild
  dragHandle?: ComponentChild
  content: Content
}

interface State {
  title: string
  featuredTopics: Array<FeaturedTopic>
  firstTopicsNumber: number
  buttonLabel: string
  buttonURL: string
  originalTopics: Array<FeaturedTopic>
}

export class FeaturedTopics extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      firstTopicsNumber: props.content.firstTopicsNumber || 0,
      buttonLabel: props.content.buttonLabel || '',
      buttonURL: props.content.buttonURL || '',
      featuredTopics: [],
      title: props.title || '',
      originalTopics: [],
    }

    this.setValue = this.setValue.bind(this)
    this.onChangeFirstTopicsNumber = this.onChangeFirstTopicsNumber.bind(this)
    this.onChangeButtonLabel = this.onChangeButtonLabel.bind(this)
    this.onChangeButtonURL = this.onChangeButtonURL.bind(this)
    this.onChangeTitle = this.onChangeTitle.bind(this)
    this.onChangeSend = this.onChangeSend.bind(this)
  }
  async componentDidMount () {
    const { data }: AxiosResponse<{content: FeaturedTopic[]}> = await axios.get('/homepage/featuredTopics', {
      params: {
        topicIds: this.props.content.topics
      }
    })

    this.setState({
      featuredTopics: data.content
    })
  }

  onChangeFirstTopicsNumber (newFirstTopicsNumber: number) {
    this.setState({
      firstTopicsNumber: newFirstTopicsNumber
    }, () => this.onChangeSend())
  }

  onChangeButtonLabel (newButtonLabel: string) {
    this.setState({
      buttonLabel: newButtonLabel,
    }, () => this.onChangeSend())
  }

  onChangeButtonURL (newButtonURL: string) {
    this.setState({
      buttonURL: newButtonURL
    }, () => this.onChangeSend())
  }

  onChangeTitle (newTitle: string) {
    this.setState({
      title: newTitle
    }, () => this.onChangeSend())
  }

  setValue (key: string, value: Array<FeaturedTopic>) {
    this.setState({
      featuredTopics: value
    }, () => this.onChangeSend())
  }

  onChangeSend () {
    const newData: NewData = {
      title: this.state.title,
      firstTopicsNumber: this.state.firstTopicsNumber,
      topics: this.state.featuredTopics && this.state.featuredTopics.map((t) => ({id: t.id, type: t.contentType})),
      buttonLabel: this.state.buttonLabel,
      buttonURL: this.state.buttonURL
    }

    this.props.onChange(newData)
  }

  render (props : Props, state : State) {
    return (
      <div class='featured-topics'>
        <div>
          <InputGroup
            title='Title'
            type='text'
            qaClasses='qa-featured-topics-widget_title'
            onChange={(e: {target: HTMLInputElement}) => { this.onChangeTitle(e.target.value) }}
            value={state.title} />
        </div>
        <div class='featured-topics__first-topics-width'>
          <p class='featured-topics__first-topics-width-text'>
            Display first
            <input
              type='number'
              onChange={(e) => {
                if (!isInputEl(e.target)) return
                this.onChangeFirstTopicsNumber(parseInt(e.target.value, 10))
              }}
              value={state.firstTopicsNumber}
              min={0} />
            topics full-width on desktop
          </p>
        </div>
        <FeaturedTopicsManager
          searchPlaceholder='Add a topic by pasting topic URL or searching'
          onUpdate={(key, value) => this.setValue(key, value)}
          featuredTopics={state.featuredTopics}
          title='Topics'
        />
        <div class='featured-topics__buttons'>
          <InputGroup
            title='Button label (optional)'
            type='text'
            placeholder='Show more'
            onChange={(e: {target: HTMLInputElement}) => { this.onChangeButtonLabel(e.target.value) }}
            value={state.buttonLabel}
          />
            <InputGroup
            title='URL (optional)'
            type='url'
            placeholder='https://example.com'
            onChange={(e: {target: HTMLInputElement}) => { this.onChangeButtonURL(e.target.value) }}
            value={state.buttonURL}
          />
        </div>
      </div>
    )
  }
}

interface PanelProps extends Props {
  dragHandle: JSX.Element
  switcher: JSX.Element
}

const FeaturedTopicsPanel = (props: PanelProps) => (
  <Panel
    collapsible
    customClass='homepage-widget featured-topics-widget'
    title={<div class='panel-title-with-switch'>
      <div class='homepage-reorderable-panel-title'>
        { props.dragHandle }
        <span>Featured Topics</span>
      </div>
      { props.switcher }
    </div>}>
    <FeaturedTopics {...props} />
  </Panel>
)

export default FeaturedTopicsPanel
